export * from './sidenav';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/sidenav/index.js
// module id = 667
// module chunks = 3